module.exports = __webpack_public_path__ + "img/43-20201002.30f3f027.jpg";